<template lang="pug">
v-col(cols="12").pa-0
  v-autocomplete(
    ref="input"
    v-model="payload.region"
    return-object
    v-bind="$attrs"
    :label="payload.region || !hoveredRegion ? label : hoveredRegion"
    :items="filteredRegions"
    item-text="name"
    hide-details
    :disabled="disabled"
    clearable
    @change="setItem($event)"
    @click:clear="reset"
  ).mb-4
  v-expand-transition
    region-map#mapRegions(v-show="!payload.region || onlyRegion")
  v-expand-transition
    AutocomplateMunitipality(
      v-model="payload.municipality" v-if="payload.region && !onlyRegion" :region="payload.region"
      @region="payload.region.id = $event"
    )
</template>

<script>
import AutocomplateMunitipality from '@/components/InputFields/AutocompleteMunitipality.vue';
import RegionMap from './region-map.svg';

const REGIONS = require('./region-list.json');
// const REGIONS_PFDO = require('./region-list-pfdo.json');

const delay = (elem, callback) => {
  let timeout = null;
  elem.onmouseover = () => { timeout = setTimeout(callback, 50); };
  elem.onmouseout = () => clearTimeout(timeout);
};

export default {
  name: 'SvgMap',
  components: {
    AutocomplateMunitipality,
    RegionMap,
  },
  props: {
    value: { type: Object, default: () => ({ region: null, municipality: null }) },
    pfdoRegions: { type: Boolean, default: false },
    onlyRegion: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    label: { type: String, default: 'Наименование' },
  },
  data() {
    return {
      payload: this.value,
      hoveredRegion: null,
      regions: REGIONS,
      search: '',
      regionsDOMCollection: null,
    };
  },
  computed: {
    filteredRegions() {
      if (!this.search) return this.regions;
      return this.regions.filter(
        (i) => (i.name.toLowerCase().includes(this.search.toLowerCase())),
      );
    },
  },
  watch: {
    'payload.region': {
      handler(val, oldval) {
        if (!val || val.id !== oldval?.id) this.payload.municipality = null;
      },
    },
    deep: true,
  },
  mounted() {
    this.regionsDOMCollection = Array.from(
      document.getElementsByClassName('region-map-item'),
      (i) => {
        const code = Number(i.getAttributeNS(null, 'data-region'));
        return { el: i, code };
      },
    );
    this.initMap();
  },
  methods: {
    getItemByCode(code) {
      return this.regions.find((item) => code === item.code);
    },
    moveToItem(item, smooth) {
      const { $refs } = this;
      const [component] = $refs[item.code];

      if (component) {
        $refs.listRegions.scroll({
          top: component.$el.offsetTop - $refs.listRegions.offsetTop,
          behavior: smooth && 'smooth',
        });
      }
    },
    setItem(item) {
      if (item) {
        this.regionsDOMCollection.forEach(({ el, code }) => {
          if (code === item.code) {
            el.classList.add('current-region');
          } else {
            el.classList.remove('current-region');
          }
        });
        this.payload.region = item;
      }
    },
    reset() {
      this.$refs.input.blur();
      this.regionsDOMCollection.forEach(({ el }) => {
        el.classList.remove('current-region');
      });
      this.hoveredRegion = null;
    },
    initMap() {
      this.regions = this.regions
        .map((i) => ({ ...i, active: false }))
        .sort((a, b) => (a.name > b.name ? 1 : -1));

      this.regionsDOMCollection.forEach(({ el: region, code }) => {
        if (!this.regions.find((r) => r.code === code)) {
          region.classList.add('disabled');
          return;
        }

        region.addEventListener('click', () => {
          const selectedRegion = this.getItemByCode(code);
          this.regionsDOMCollection.forEach(({ el }) => {
            el.classList.remove('current-region');
          });
          region.classList.add('current-region');

          this.$set(this.payload, 'region', selectedRegion);
          // this.payload.region = selectedRegion;
        });

        delay(region, () => {
          const selectedRegion = this.getItemByCode(code);
          selectedRegion.active = true;
          this.hoveredRegion = selectedRegion.name;
        });

        region.addEventListener('mouseleave', () => {
          const selectedRegion = this.getItemByCode(code);
          this.hoveredRegion = null;
          selectedRegion.active = false;
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.svg-map {
  .list-regions {
    max-height: 400px;
    padding-top: 0;
    padding-bottom: 0;

    .hovered-item {
      background-color: var(--primary-color);

      div {
        color: var(--light-color);
      }
    }
  }

  ::-webkit-scrollbar {
    width: 2px;
  }

  ::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  ::-webkit-scrollbar-thumb {
    background: #888;
  }
}
</style>

<style lang="scss">
#mapRegions {
  .region-map-item {

    &.disabled {
      background-color: white;
      opacity: 0.5;
      stroke-width: 1px;

      &:hover {
        opacity: 0.5;
        stroke-width: 1px;
      }
    }

    &:not(.disabled):hover {
      cursor: pointer;
      opacity: 0.8;
      stroke-width: 2px;
    }
  }

  .current-region {
    opacity: 0.8;
    stroke-width: 2px;
  }

  @media (max-width: 679px) {
    height: auto !important;
  }
}
</style>

<style lang="scss" scoped>
.list-regions {
  max-height: 350px;
  padding-top: 0;
  padding-bottom: 0;

  .secondary .v-list-item-title {
    color: white;
  }
}

.scroll-y {
  overflow-y: auto;
}
</style>
